module.exports = __webpack_public_path__ + "img/lobby_hosting_smf.9dc14179.png";